import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { Funcionalidad } from '../../_models/funcionalidad';
import { NavService } from '../../_services/_nav.service';
import { Router } from '@angular/router';
import { AutenticacionService } from '../../_services/autenticacion.service';
import {TiposProductores} from '../../_models/tipos-productores';
import {TipoProductoresService} from '../../_services/tipo-producto.service';

@Component( {
  selector: 'app-tipo-productores-listado',
  templateUrl: 'tipo-productores-listado.component.html'
} )

export class TipoProductoresListadoComponent implements OnInit {

  lisTiposProductores: TiposProductores[] = [];
  carTabla = true;
  columnas: any[];
  busqueda: string;
  @ViewChild('dt', { static: true }) tabla: Table;
  menu: Funcionalidad = new Funcionalidad();
  mosDetalle = false;
  tiposProductoresSeleccionada: TiposProductores;

  constructor( private tipoProductoresService: TipoProductoresService,
               private navServicio: NavService,
               private router: Router,
               private autServicio: AutenticacionService ) {
  }

  ngOnInit(): void {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/tipo-productores' );
    if ( mn ) {
      this.menu = mn;
    }

    this.columnas = [
      { field: 'codigo', header: this.navServicio.buscarMensaje( 'GARANTIASIDONEAS.LBL_TIPOPRODUCTORCODIGO' ), sort: true },
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'GARANTIASIDONEAS.LBL_TIPOPRODUCTORNOMBRE' ), sort: true },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
    this.busqueda = this.navServicio.getSearch( 'tipo-productores.component' );

    this.tipoProductoresService.listado().subscribe( tiposProductores => {
      this.lisTiposProductores = tiposProductores;
      this.carTabla = false;
      this.tabla.filterGlobal( this.busqueda, 'contains' );
    } );

    this.carTabla = false;
  }


  crear() {
    this.router.navigate( [ 'apl/tipo-productores/agregar' ] );
  }

  ver( palClave: TiposProductores ) {
    this.router.navigate( [ 'apl/tipo-productores/detalle/' + palClave.idTipoProductor] );
  }

  editar( palClave: TiposProductores ) {
    this.router.navigate( [ 'apl/tipo-productores/actualizar/' + palClave.idTipoProductor ] )
  }

  setBusqueda() {
    this.navServicio.setSearch( 'tipo-productores.component', this.busqueda );
  }

  cerrar() {
    this.mosDetalle = false;
  }


}
